import { ref, watch } from 'vue'
import { defineStore } from 'pinia'
import { useEcho } from '@/composables/echo'
import { useApi } from '@/composables/api'
import { useStorage } from '@/composables/storage'

export const useEchoStore = defineStore('echo', () => {
	const { echoClient } = useEcho()

	const newOrders = ref(0)
	const newMessages = ref(0)
	const event = ref(null)
	const action = ref(null)
	const newOrderData = ref(null)
	const data = ref(null)
    const newTicketMessages = ref(0)
    const newChatMessages = ref(0)

	if (echoClient) {
		const storage = useStorage()
		const user = storage.getJson('user')
		const hasAccessToAdminChannels = user && user.roles && user.roles.some(role => {
			const roleName = typeof role === 'string' ? role : (role.name || role.key);
			return ['admin', 'manager'].includes(roleName);
		});

		if (hasAccessToAdminChannels) {
			echoClient.private('admin').listen('.OrderUpdate', (e) => {
				newOrders.value = e.count.new
				event.value = 'OrderUpdate'
				action.value = e.action

				if (e.action == 'created') {
					document.getElementById('sound-file').play()
				}
				console.log('Order')
			})


			echoClient.private('admin').listen('.MessageUpdate', (e) => {
				// 👇 ВОТ ЭТА СТРОКА САМАЯ ВАЖНАЯ ДЛЯ ДИАГНОСТИКИ
				console.log('ПОЛУЧЕНО СОБЫТИЕ .MessageUpdate:', e);

				if (e.count?.tickets !== undefined) {
					newTicketMessages.value = e.count.tickets;
				}
				if (e.count?.chats !== undefined) {
					newChatMessages.value = e.count.chats;
				}
			});

			echoClient.private('admin').listen('.SendChat', (e) => {
				event.value = 'SendChat'
				data.value = e
				document.getElementById('sound-fileChat').play()
				console.log('Chat')

			})

			echoClient.private('admin').listen('.SendMessageTicket', (e) => {
				event.value = 'SendMessageTicket'
				data.value = e
				document.getElementById('sound-fileMesaage').play()
				console.log('Message')
			})


			useApi(true, 'index', 'orders', { where_model: { value: 'count_new' } }, null, false).then(
				(response) => {
					if (response.ok.value) {
						newOrders.value = response.result.value.meta.total
					}
				}
			)

			useApi(true, 'index', 'messages', { where_model: { value: 'count_new' } }, null, false).then(
				(response) => {
					if (response.ok.value) {
						newMessages.value = response.result.value.meta.total
					}
				}
			)
		}
	}

	return { newOrders, newOrderData, newMessages, newTicketMessages,newChatMessages, event, action, data }
})
